










import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ContactMessage extends Vue {
  @Prop()
  protected heading?: string;
}
